<template>
  <div>
    <div class="header">
      <YMIcon />
    </div>
  </div>
</template>
<style scoped>
  .header {
    padding: 20px;
    box-shadow: 0 -1px 1px 1px rgba(39, 39, 39, 1);
  }
</style>
